// src/components/common/BackButton.tsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';

interface BackButtonProps {
    to?: string;
    onClick?: () => void;
    label?: string;
    className?: string;
}

const BackButton: React.FC<BackButtonProps> = ({ to, onClick, label, className = "" }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const resolvedLabel = label ?? t('common.back');

    const handleClick = () => {
        if (onClick) onClick();
        else if (to) navigate(to);
        else navigate(-1);
    };

    return (
        <button 
            onClick={handleClick} 
            className={`
                group flex items-center gap-2 
                text-xs font-bold text-gray-400 hover:text-white 
                uppercase tracking-widest px-5 py-2.5 rounded-xl 
                bg-white/5 border border-white/5 hover:border-white/10
                backdrop-blur-sm transition-all duration-300 w-fit
                ${className}
            `}
        >
            <ArrowLeft className="group-hover:-translate-x-1 transition-transform duration-300" />
            <span>{resolvedLabel}</span>
        </button>
    );
};

export default BackButton;
